"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Avatar.scss");
var Avatar = function (props) { return (react_1.default.createElement("div", { className: classnames_1.default('avatar', { clickable: props.onClick, selected: props.selected }, props.className), onClick: props.onClick, "data-tooltip": props.title },
    props.text,
    props.children)); };
exports.Avatar = Avatar;
